import Types from "./Types";

const INITIAL_STATE = {
  requests: [],
  chapter: {},
  isLoading: false,
  count: "",
};

export default function requests(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_REQUESTS_SUCCESS: {
      return {
        ...state,
        requests: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_REQUEST_SUCCESS: {
      return {
        ...state,
        chapter: payload,
      };
    }

    case Types.EDIT_REQUEST_SUCCESS: {
      const newrequests = state.requests.filter((item) => item.id !== payload);

      return {
        ...state,
        requests: newrequests,
      };
    }

    case Types.ACCEPT_REQUEST_WITHOUT_VOUCHER_SUCCESS: {
      const newrequests = state.requests.filter((item) => item.id !== payload);

      return {
        ...state,
        requests: newrequests,
      };
    }

    // create
    case Types.CREATE_REQUEST_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.requests.slice();
      let index = state.requests.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        requests: newArray,
      };
    }

    case Types.DELETE_REQUEST_SUCCESS: {
      const newrequests = state.requests.filter((item) => item.id !== payload);
      return {
        ...state,
        requests: newrequests,
      };
    }

    case Types.ADD_REQUESTS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }
    default: {
      return state;
    }
  }
}
